import { Comparator } from 'library/ts/utilities/compare/Comparator';
export const compare = (leftSubject, rightSubject, settings = {}) => {
    let comparator = new Comparator(settings);
    const results = comparator.compareObjects(leftSubject, rightSubject);
    comparator = undefined;
    return results;
};
